var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMyplan(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Union_23",
    "data-name": "Union 23",
    d: "M4,19a4,4,0,0,1-4-4V4A4,4,0,0,1,4,0H15a4,4,0,0,1,4,4V15a4,4,0,0,1-4,4ZM1.8,4V15A2.2,2.2,0,0,0,4,17.2H15A2.2,2.2,0,0,0,17.2,15V4A2.2,2.2,0,0,0,15,1.8H4A2.2,2.2,0,0,0,1.8,4ZM13.246,14.545l-.692-.693a.4.4,0,0,1,.566-.565l.41.41,1.24-1.241a.4.4,0,0,1,.566.566l-1.524,1.524a.4.4,0,0,1-.566,0ZM4.5,14.4a.9.9,0,0,1,0-1.8h5a.9.9,0,0,1,0,1.8Zm8.746-3.856-.692-.692a.4.4,0,0,1,.566-.566l.41.41,1.24-1.24a.4.4,0,0,1,.566.565l-1.524,1.524a.4.4,0,0,1-.566,0ZM4.5,10.4a.9.9,0,0,1,0-1.8h5a.9.9,0,0,1,0,1.8Zm8.746-3.856-.692-.693a.4.4,0,0,1,.566-.565l.41.41,1.24-1.241a.4.4,0,0,1,.566.566L13.812,6.545a.4.4,0,0,1-.566,0ZM4.5,6.4a.9.9,0,1,1,0-1.8h5a.9.9,0,0,1,0,1.8Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMyplan);
export default __webpack_public_path__ + "static/media/myplan.fc3b94a1a0c221d8fd78812426e6ba60.svg";
export { ForwardRef as ReactComponent };